import { Grid, Modal, CardContent } from '@mui/material'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { deleteItem, getOne, updateItem } from '../../services/Api/request'
import CustomizedProgress from '../customElements/CircularProgress'

export default function ModalViewClient({
  open,
  onClose,
  view: clientId,
  collaborateurId = null,
}) {
  const { register, handleSubmit } = useForm()
  const queryClient = useQueryClient()

  const { data: client, isLoading } = useQuery(
    ['clients', clientId],
    async () => {
      const data = await getOne(`clients/${clientId}`)
      return data
    },
    {
      enabled: true,
    }
  )

  const { mutate: updateClient, isLoading: isUpdating } = useMutation(
    async (data) => {
      const response = await updateItem('clients', {
        id: clientId,
        body: JSON.stringify(data),
      })
      return response
    },
    {
      onSuccess: () => {
        toast.success('Client mis à jour')
        if (collaborateurId) {
          queryClient.refetchQueries(['collaborateurs', collaborateurId])
        } else {
          queryClient.refetchQueries(['clients'])
        }
        onClose()
      },
    }
  )
  const { mutate: deleteClient, isLoading: isDeleting } = useMutation(
    async () => {
      const response = await deleteItem('clients', {
        id: clientId,
      })
      return response
    },
    {
      onSuccess: () => {
        toast.success('Client supprimé')
        if (collaborateurId) {
          queryClient.refetchQueries(['collaborateurs', collaborateurId])
        } else {
          queryClient.refetchQueries(['clients'])
        }
        onClose()
      },
    }
  )

  return (
    <Modal open={open} onClose={onClose}>
      <div className="card-modal">
        <div className="card">
          {isLoading ? (
            <CustomizedProgress />
          ) : (
            <form onSubmit={handleSubmit(updateClient)}>
              <CardContent>
                <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={12} sm={12} md={2}>
                    <label htmlFor="inputCivility">Civilité</label>
                    <div className="input">
                      <select
                        id="inputCivility"
                        name="civilite"
                        type="civility"
                        defaultValue={client.civilite}
                        {...register('civilite')}
                      >
                        <option value="M">M.</option>
                        <option value="Mme">Mme</option>
                      </select>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <label htmlFor="inputLastName">Nom</label>
                    <div className="input">
                      <input
                        id="inputLastname"
                        className="form-control"
                        name="nom"
                        type="text"
                        placeholder="Nom"
                        defaultValue={client.nom}
                        {...register('nom')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <label htmlFor="inputFirstName">Prénom</label>
                    <div className="input">
                      <input
                        id="inputFirstname"
                        className="form-control"
                        name="prenom"
                        type="text"
                        placeholder="Prénom"
                        defaultValue={client.prenom}
                        {...register('prenom')}
                      />
                    </div>
                  </Grid>

                  {client.type.includes('pro') && (
                    <>
                      <Grid item xs={12} sm={12} md={6}>
                        <label htmlFor="inputSociety">Société</label>
                        <div className="input">
                          <input
                            id="inputSociety"
                            className="form-control"
                            name="societe"
                            type="text"
                            placeholder="Société"
                            defaultValue={client.societe}
                            {...register('societe')}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <label htmlFor="inputJob">Poste</label>
                        <div className="input">
                          <input
                            id="inputJob"
                            className="form-control"
                            name="poste"
                            type="text"
                            placeholder="Poste"
                            defaultValue={client.poste}
                            {...register('poste')}
                          />
                        </div>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={12} md={6}>
                    <label htmlFor="inputAddress">Adresse de livraison</label>
                    <div className="input">
                      <input
                        id="inputAddress"
                        className="form-control"
                        name="adresse"
                        type="text"
                        placeholder="Adresse postale"
                        defaultValue={client.adresse}
                        {...register('adresse')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    <label htmlFor="inputCP">Code postal</label>
                    <div className="input">
                      <input
                        id="inputCP"
                        className="form-control"
                        name="codePostal"
                        type="number"
                        placeholder="33000"
                        defaultValue={client.codePostal}
                        {...register('codePostal')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    <label htmlFor="inputCity">Ville</label>
                    <div className="input">
                      <input
                        id="inputCity"
                        className="form-control"
                        name="ville"
                        type="text"
                        placeholder="Ville"
                        defaultValue={client.ville}
                        {...register('ville')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <label htmlFor="inputEmail">Adresse e-mail</label>
                    <div className="input">
                      <input
                        id="Email"
                        className="form-control"
                        name="email"
                        type="email"
                        placeholder="Adresse e-mail"
                        defaultValue={client.email}
                        {...register('email')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <label htmlFor="inputPhone">Téléphone</label>
                    <div className="input">
                      <input
                        id="Phone"
                        className="form-control"
                        name="telephone"
                        type="phone"
                        placeholder="Numéro de téléphone"
                        defaultValue={client.telephone}
                        {...register('telephone')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} display="flex">
                    <button
                      type="button"
                      className="btn-delete"
                      style={{ marginLeft: 'auto' }}
                      onClick={deleteClient}
                    >
                      <em>
                        {isDeleting ? (
                          <CustomizedProgress />
                        ) : (
                          'Supprimer le contact'
                        )}
                      </em>
                    </button>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <button type="submit" className="btn">
                      <em>
                        {isUpdating ? (
                          <CustomizedProgress />
                        ) : (
                          'Enregister les modifications'
                        )}
                      </em>
                    </button>
                  </Grid>
                </Grid>
              </CardContent>
            </form>
          )}
        </div>
      </div>
    </Modal>
  )
}
